import type { WifiInfo } from '@/data/types';

interface FooterProps {
  /** WiFi for the active event, when published. Omitted years hide the block. */
  wifi?: WifiInfo;
}

export function Footer({ wifi }: FooterProps) {
  return (
    <footer className="mt-12 border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2 sm:gap-8">
          {/* WiFi Information — only shown once the venue's network is confirmed */}
          {wifi && (
            <div className="text-center sm:text-left">
              <h2 className="text-sm font-medium text-gray-900 sm:text-base dark:text-white">
                WiFi Information
              </h2>
              <div className="mt-3 space-y-1 text-xs text-gray-600 sm:text-sm dark:text-gray-400">
                <p>
                  <span className="font-medium">Network:</span> {wifi.network}
                </p>
                <p>
                  <span className="font-medium">Password:</span> {wifi.password}
                </p>
              </div>
            </div>
          )}

          {/* Contact Information */}
          <div className="text-center sm:text-left">
            <h2 className="text-sm font-medium text-gray-900 sm:text-base dark:text-white">
              Need Assistance?
            </h2>
            <p className="mt-2 text-xs text-gray-600 sm:text-sm dark:text-gray-400">
              For questions about logistics, accommodations, or travel, please
              contact:
            </p>
            <div className="mt-3 space-y-1 text-xs text-gray-600 sm:text-sm dark:text-gray-400">
              <p>
                <a
                  href="mailto:rsvp@twobearcapital.com"
                  className="hover:text-primary-600 dark:hover:text-primary-400"
                >
                  rsvp@twobearcapital.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
